import { NavLink } from 'react-router-dom';

export const Contact = () => {
  return(
    <div className='container'>
    <header>
        <h1>contate-nos</h1>
        <p>tem alguma dúvida ou sugestão? estamos aqui para ajudar!</p>
      </header>

      <section>
        <h2>outros canais de contato</h2>
        <p><strong>e-mail de suporte:</strong> <NavLink to="mailto:comandosdev@gmail.com">comandosdev@gmail.com</NavLink></p>
        <p><strong>redes sociais:</strong></p>
        <ul>
          <li>twitter: <NavLink to="https://twitter.com/comandosdev" target="_blank" rel="noopener noreferrer"> @comandosdev</NavLink></li>
          <li>gitHub: <NavLink to="https://github.com/comandos-dev" target="_blank" rel="noopener noreferrer">comandosdev</NavLink></li>
        </ul>
      </section>
    </div>
  );
};